import { TransmissionType, VehicleFuelType } from "@/types/enums";

// The backend stores fuel type and transmission as enum values ("DIESEL", "AUTOMATIC"),
// while the form's option buttons (DetailsSection) are keyed on the Swedish values a fresh
// registration lookup gives ("Diesel", "Automat"). A saved test reopened in the form must
// be translated back, otherwise no button is highlighted. The backend accepts both forms
// on save, so this only affects what the form shows and compares against.
const FUEL_TYPE_TO_FORM: Record<string, string> = {
  [VehicleFuelType.GASOLINE]: "Bensin",
  [VehicleFuelType.DIESEL]: "Diesel",
  [VehicleFuelType.ELECTRIC]: "El",
  [VehicleFuelType.HYBRID]: "Hybrid",
  [VehicleFuelType.PLUG_IN_HYBRID]: "Laddhybrid",
  [VehicleFuelType.GAS]: "Gas",
  [VehicleFuelType.ETHANOL]: "Etanol",
  [VehicleFuelType.OTHER]: "Annat",
};

// TransmissionType.OTHER has no button in the form, so it is left as stored.
const TRANSMISSION_TO_FORM: Record<string, string> = {
  [TransmissionType.AUTOMATIC]: "Automat",
  [TransmissionType.MANUAL]: "Manuell",
  [TransmissionType.SEMI_AUTOMATIC]: "Halvautomatisk",
  [TransmissionType.CVT]: "CVT",
};

export const storedVehicleDetailsToForm = <
  T extends { fuelType?: unknown; transmission?: unknown },
>(
  details: T,
): T => {
  const result = { ...details };
  if (typeof details.fuelType === "string" && FUEL_TYPE_TO_FORM[details.fuelType]) {
    result.fuelType = FUEL_TYPE_TO_FORM[details.fuelType];
  }
  if (
    typeof details.transmission === "string" &&
    TRANSMISSION_TO_FORM[details.transmission]
  ) {
    result.transmission = TRANSMISSION_TO_FORM[details.transmission];
  }
  return result;
};
